import React from "react";
import styled from "styled-components";

import { Strings } from "--root/strings/en";

import { Button } from "--floponents-web/atoms/Button";
import { Form } from "--floponents-web/atoms/Form";
import SurfaceBody from "--floponents-web/atoms/Surface/SurfaceBody";
import SurfaceHeader from "--floponents-web/atoms/Surface/SurfaceHeader";
import { Body2, Heading5 } from "--components/typography";
import { DialogCloseButton } from "--floponents-web/molecules/DialogCloseButton/DialogCloseButton";

const StyledBeforeNavigateDialog = styled.form`
    display: contents;
`;

const BeforeNavigateDialogButtonBox = styled.div`
    display: flex;
    gap: ${props => props.theme.spacing(1)};
    justify-content: end;
`;

export interface BeforeNavigateDialogMeta {
    title?: string;
    message?: string;
    confirmText?: string;
    allowUrl?: (url: string) => boolean
}

export interface BeforeNavigateDialogProps extends BeforeNavigateDialogMeta {
    onConfirm?: () => void;
    onClose?: () => void;
}

const BeforeNavigateDialog = (props: BeforeNavigateDialogProps) => (
    <StyledBeforeNavigateDialog>
        <SurfaceHeader>
            <Heading5>{props.title ?? Strings.navBlock.title}</Heading5>
            <DialogCloseButton onClick={props.onClose} />
        </SurfaceHeader>
        <SurfaceBody>
            <Form.BasicForm>
                <Body2>{props.message ?? Strings.navBlock.message}</Body2>
                <BeforeNavigateDialogButtonBox>
                    <Button color="danger" onClick={props.onConfirm}>
                        {props.confirmText ?? Strings.yes}
                    </Button>
                    <Button color="grey" onClick={props.onClose}>
                        {Strings.cancel}
                    </Button>
                </BeforeNavigateDialogButtonBox>
            </Form.BasicForm>
        </SurfaceBody>
    </StyledBeforeNavigateDialog>
);

export default BeforeNavigateDialog;
